import { render } from "./mvt-compliance.vue?vue&type=template&id=0b784a25"
import script from "./mvt-compliance.js?vue&type=script&lang=js"
export * from "./mvt-compliance.js?vue&type=script&lang=js"

import "./mvt-compliance.vue?vue&type=style&index=0&id=0b784a25&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__